import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AuthorityDAO} from '../models/DAO/authority';
import {HttpService} from './http.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {environment} from 'projects/frontend/src/environments/environment';
import {AreaPersonale, Pagamento, PosizioneDebitoria, PosizioneDebitoria_PagamentiRecenti_Pagata} from "../models/payment-area/payment-area.model";
import {AppConfigService} from "./appconfig.service";
import {
  BehaviorSubject,
  combineLatest,
  distinctUntilChanged,
  Observable,
  timer,
  ObservableInput,
} from "rxjs";
import {map, shareReplay, finalize} from "rxjs/operators";
import {GetEnteViewModel, TipologiaSegnalazioneViewModel} from "./models/get-ente.models";
import {PathStore} from "../store/path.store";

@Injectable({providedIn: 'root'})
export class StoreService {
  languagesCollection: any[] = [];
  authoritiesCollection: AuthorityDAO[] = [];

  authority: AuthorityDAO | undefined;
  authoritySubject = new BehaviorSubject<AuthorityDAO | undefined>(undefined)
  /**
   * todo use only this observble to retrieve actual autority
   * also we need to unify this http call to InstitutionCategoriesService
   * into categoriesService observable
   */
  authority$ = this.authoritySubject.asObservable()
  tipologieSegnalazione$: Observable<TipologiaSegnalazioneViewModel[]> = this.authority$.pipe(map(s => s?.configurazioneHelpDesk?.tipologiaSegnalazione ?? []))

  debtPositionsData: AreaPersonale | undefined;
  debtPositions: PosizioneDebitoria[] = []
  debtPositionsScadute: PosizioneDebitoria[] = []
  debtPositionsInScadenza: PosizioneDebitoria[] = []
  debtPositionsPagate: PosizioneDebitoria[] = []
  debtPositionsPagamentiRecenti: Pagamento[] = []

  debtPositionsPagamentiRecenti_debtPositionsPagate: PosizioneDebitoria_PagamentiRecenti_Pagata[] = []

  private dataAggiornamento = new BehaviorSubject<Date | undefined>(undefined)
  dataAggiornamento$ = this.dataAggiornamento.asObservable();
  private prossimaDataAggiornamento$ = this.dataAggiornamento$
    .pipe(
      map(d => d == null ? undefined : new Date(new Date(d).setMinutes(new Date(d).getMinutes() + 5))),
      distinctUntilChanged());
  disableAggiornamentoButton$: Observable<boolean> = combineLatest(
    [this.prossimaDataAggiornamento$, timer(0, 5000)])
    .pipe(map(([prossimaDataAggiornamento]) => prossimaDataAggiornamento != null ? prossimaDataAggiornamento > new Date() : true))

  codIpa: string = ""
  fiscalNumber: string = ""
  public nomeEnte: string | null = ""
  private authorityRequest$: Observable<GetEnteViewModel> | null = null;

  public searchTerm = '';
  public searchPageCount = 1;
  public searchCurrentPageIndex = 1;
  public noResultEnti: boolean = false
  private authorityConfigurationUpdateDate: Date | undefined;

  // POPUP inserimento CF e EMAIL per ANONIMO
  public emailUtentePagamentoAnonimo: string = '';
  public codiceFiscaleUtentePagamentoAnonimo: string = '';
  // [x] - WorkItem 11520: Aggiungere nuovo campo "pagamentoIsAnonimo" per distinguere i pagamenti anonimi (codice fiscale utente = 'ANONIMO') dagli altri pagamenti
  public pagamentoIsAnonimo: boolean = false;
  public modelloPagamentoAnonimo: number = 1;

  constructor(
    private translationService: TranslateService,
    private appConfigService: AppConfigService,
    public path: PathStore,
    private httpService: HttpService,
    private spinner: NgxSpinnerService,
  ) {
    // console.log('TITLE', this.appConfigService.getConfig().settings?.title);
    // console.log(this.appConfigService.getConfig())
  }

  getLanguagesCollection() {
    const config = this.appConfigService.getConfig();
    const apiUrl = config?.settings?.apiServer.endPoint + '' + config?.settings?.api?.languages;
    this.httpService.getCallHttp(apiUrl)
      .subscribe((res: any) => {
          if (res.result) {
            this.languagesCollection = res.result.supportedLocales;
            this.setLanguageFlagDefault();
          }
        }
      );
  }
  setLanguageFlagDefault() {
    const efilLangToUse = localStorage.getItem('efil-lang-to-use');
    const langBrowser = this.translationService.getBrowserLang() ?? 'it';
    let langToUse = langBrowser.toLowerCase();
    if(efilLangToUse && efilLangToUse != null && efilLangToUse != '') {
      langToUse = efilLangToUse.toLowerCase();
    }
    this.languagesCollection.forEach(l => {
      l.default = l.code.toLowerCase() == langToUse;
    });
  }
  searchAuthoritiesCollection(term: string, pageCount: number, currentPageIndex: number) {
    this.searchTerm = term;
    this.searchPageCount = pageCount;
    this.searchCurrentPageIndex = currentPageIndex;

    this.spinner.show();
    const config = this.appConfigService.getConfig();
    const apiUrl = config?.settings?.apiServer.endPoint + '' + config?.settings?.api?.search + `?filter=${term}&page=${this.searchPageCount}&items=${config?.settings?.searchPageSize}`;
    this.httpService.getCallHttp(apiUrl)
      .subscribe({
        next: (res: any) => {
          if (res && res != '' && res.result && res.result != '') {
            this.authoritiesCollection = [];
            const lang = this.translationService.currentLang;
            if (res.result.enti.length > 0) {
              this.authoritiesCollection = res.result.enti;
              this.fixAuthoritiesCollection(lang);
              this.initSearchPaginator(res.result);
            }
          }
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        }
      });
  }
  fixAuthoritiesCollection(lang: string) {
    this.authoritiesCollection.forEach(e => {
      if (e.locales.length > 0) {
        // Verifico la lingua corrente con quelle definite per l'ente
        e.locales.forEach(locale => {
          locale.active = lang.trim().toLowerCase().indexOf(locale.locale.toLowerCase()) !== -1;
        });
        // Se non trovo una corrispondenza imposto la prima come ACTIVE
        let langFound: boolean = false;
        e.locales.forEach(locale => {
          if (locale.active) {
            langFound = true;
          }
        });
        if (!langFound) {
          e.locales[0].active = true;
        }
      }
    });
  }

  initSearchPaginator(searchObj: any) {
    this.searchPageCount = searchObj.pageCount; // n° di pagine
    this.searchCurrentPageIndex = searchObj.currentPageIndex; // current page
  }

  public getPaginatorChange(page: number): void {
    this.searchAuthoritiesCollection(this.searchTerm, page, page + 1)
  }

  getAuthorityInfo() {
    var autorityRefreshRateInMinutes = 5;
    // if (this.authorityConfigurationUpdateDate != undefined) {
    //   var dateDifference =  (new Date().getTime() - this.authorityConfigurationUpdateDate.getTime());
    //   var dateDifferenceInMinutes = dateDifference/(1000 * 60);
    //   console.log('dateDifferenceInMinutes', dateDifferenceInMinutes);
    //   console.log('authorityConfigurationUpdateDate', this.authorityConfigurationUpdateDate);
    //   console.log('dateDifference', dateDifference);
    // }
    // console.groupEnd();

    if (this.authority?.codiceIpaEnte.toUpperCase() === this.codIpa.toUpperCase()
      && this.authorityConfigurationUpdateDate != undefined
      &&  (new Date().getTime() - this.authorityConfigurationUpdateDate.getTime())/(1000 * 60) < autorityRefreshRateInMinutes) {
        localStorage.setItem('authority',JSON.stringify(this.authority));
        return;
    }

    // if there's already a request in progress, reuse it
    if (this.authorityRequest$) {
      // ensure subscription so side-effects happen
      this.authorityRequest$.subscribe();
      return;
    }

    this.spinner.show();
    const config = this.appConfigService.getConfig();
    const apiUrl = config?.settings?.apiServer.endPoint + '' + config?.settings?.api?.authority_auth + '/' + this.codIpa;
    const req$ = this.httpService.getCallHttp<GetEnteViewModel>(apiUrl)
      .pipe(
        finalize(() => {
          this.authorityRequest$ = null;
          this.spinner.hide();
        }),
        shareReplay(1)
      );

    this.authorityRequest$ = req$;

    req$.subscribe({
      next: (res: GetEnteViewModel) => {
        if (res && res.result) {
          this.authority = res.result;
          this.authorityConfigurationUpdateDate = new Date();

          if (!!this.authority?.locales[0].descrizioneBreve) {
            this.nomeEnte = this.authority?.locales[0].descrizioneBreve
          }
          const lang = this.translationService.currentLang;
          this.fixAuthorityInfo(lang);
          localStorage.setItem('authority',JSON.stringify(this.authority));
        }
      },
      error: (_err: any) => {
        this.authorityConfigurationUpdateDate = undefined;
        this.authoritySubject.next(undefined);
      }
    });
  }

  fixAuthorityInfo(lang: string) {
    if (this.authority && this.authority.locales.length > 0) {
      // Verifico la lingua corrente con quelle definite per l'ente
      this.authority.locales.forEach(locale => {
        locale.active = lang.trim().toLowerCase().indexOf(locale.locale.toLowerCase()) !== -1;
      });
      // Se non trovo una corrispondenza imposto la prima come ACTIVE
      let langFound: boolean = false;
      this.authority.locales.forEach(locale => {
        if (locale.active) {
          langFound = true;
        }
      });
      if (!langFound) {
        this.authority.locales[0].active = true;
      }
      this.setAuthObservable(this.authority);
    }
  }

  setDataAggiornamento(dataAggiornamento: Date) {
    this.dataAggiornamento.next(dataAggiornamento)
  }

  setAuthObservable(auth: AuthorityDAO | undefined) {
    // Aggiorno l'observable per AUTH: sembra che sovrascrive storeService.authority...
    this.authoritySubject.next(auth);
  }
}
